import React, { useEffect, useState, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
interface SaleEntry {
  name: string;
  initial: string;
  city: string;
  flag: string;
  time: string;
}
const SALES: SaleEntry[] = [{
  name: 'Camila',
  initial: 'R',
  city: 'Ciudad de México',
  flag: '🇲🇽',
  time: 'hace 4 minutos'
}, {
  name: 'Valeria',
  initial: 'M',
  city: 'Bogotá',
  flag: '🇨🇴',
  time: 'hace 12 minutos'
}, {
  name: 'Lucía',
  initial: 'F',
  city: 'Buenos Aires',
  flag: '🇦🇷',
  time: 'hace 7 minutos'
}, {
  name: 'Martina',
  initial: 'S',
  city: 'Madrid',
  flag: '🇪🇸',
  time: 'hace 2 minutos'
}, {
  name: 'Valentina',
  initial: 'P',
  city: 'Santiago',
  flag: '🇨🇱',
  time: 'hace 15 minutos'
}, {
  name: 'Daniela',
  initial: 'G',
  city: 'Lima',
  flag: '🇵🇪',
  time: 'hace 9 minutos'
}, {
  name: 'Sofía',
  initial: 'T',
  city: 'Guadalajara',
  flag: '🇲🇽',
  time: 'hace 6 minutos'
}, {
  name: 'Isabella',
  initial: 'L',
  city: 'Medellín',
  flag: '🇨🇴',
  time: 'hace 20 minutos'
}, {
  name: 'Fernanda',
  initial: 'B',
  city: 'Montevideo',
  flag: '🇺🇾',
  time: 'hace 11 minutos'
}, {
  name: 'Carmen',
  initial: 'A',
  city: 'Barcelona',
  flag: '🇪🇸',
  time: 'hace 3 minutos'
}, {
  name: 'Gabriela',
  initial: 'N',
  city: 'Quito',
  flag: '🇪🇨',
  time: 'hace 18 minutos'
}, {
  name: 'Antonella',
  initial: 'C',
  city: 'Guatemala',
  flag: '🇬🇹',
  time: 'hace 5 minutos'
}];
const INITIAL_DELAY = 7000; // 7s antes de la primera aparición
const VISIBLE_MS = 5500; // se muestra ~5.5s
const INTERVAL_MS = 22000; // reaparece cada ~22s
const MAX_SHOWS = 5; // máximo de apariciones por sesión
export function SalesPopup() {
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const showsRef = useRef(0);
  const scrolledRef = useRef(false);
  const hideTimer = useRef<ReturnType<typeof setTimeout>>();
  const cycleTimer = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => {
    if (dismissed) return;
    // Gate: no mostrar hasta que el usuario scrollee pasado el hero (~70% de la altura de viewport)
    const onScroll = () => {
      if (window.scrollY > window.innerHeight * 0.7) {
        scrolledRef.current = true;
      }
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    const scheduleNext = (delay: number) => {
      cycleTimer.current = setTimeout(tryShow, delay);
    };
    const tryShow = () => {
      if (dismissed || showsRef.current >= MAX_SHOWS) return;
      // Si el usuario todavía no pasó el hero, reintentar pronto sin gastar una aparición
      if (!scrolledRef.current) {
        scheduleNext(1500);
        return;
      }
      setIndex(Math.floor(Math.random() * SALES.length));
      setVisible(true);
      showsRef.current += 1;
      hideTimer.current = setTimeout(() => {
        setVisible(false);
        if (showsRef.current < MAX_SHOWS) scheduleNext(INTERVAL_MS);
      }, VISIBLE_MS);
    };
    scheduleNext(INITIAL_DELAY);
    return () => {
      window.removeEventListener('scroll', onScroll);
      clearTimeout(hideTimer.current);
      clearTimeout(cycleTimer.current);
    };
  }, [dismissed]);
  const handleClose = () => {
    setVisible(false);
    setDismissed(true);
    clearTimeout(hideTimer.current);
    clearTimeout(cycleTimer.current);
  };
  const sale = SALES[index];
  return <AnimatePresence data-id="element-281">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-40 w-[calc(100%-2rem)] max-w-xs md:bottom-6 md:left-6" role="status" aria-live="polite" data-id="element-282">
          <div className="relative bg-white rounded-2xl shadow-xl border border-gray-100 p-4 pr-9" data-id="element-283">
            <button onClick={handleClose} aria-label="Cerrar notificación" className="absolute top-2.5 right-2.5 text-gray-300 hover:text-gray-500 transition-colors" data-id="element-284">
              <X className="w-4 h-4" data-id="element-285" />
            </button>

            <div className="flex items-center gap-1.5 mb-2" data-id="element-286">
              <span className="relative flex h-2.5 w-2.5" data-id="element-287">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-288"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" data-id="element-289"></span>
              </span>
              <span className="text-[10px] font-bold tracking-widest text-green-600 uppercase" data-id="element-290">
                Compra verificada
              </span>
            </div>

            <p className="text-sm font-semibold text-brand-900 leading-snug" data-id="element-291">
              {sale.name} {sale.initial}. de {sale.city} {sale.flag}
            </p>
            <p className="text-sm text-gray-700 leading-snug" data-id="element-292">
              compró{' '}
              <strong className="text-brand-700" data-id="element-293">MegaPack Life Coach</strong> 🎯
            </p>
            <p className="text-xs text-gray-400 mt-1.5" data-id="element-294">{sale.time}</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}